"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Open: () => Open
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
async function openURL(url) {
  await import_react_native.Linking.openURL(url);
}
async function openShare(param) {
  var { title, message, url } = param;
  if (url != null && import_react_native.Platform.OS === "ios") {
    await import_react_native.Share.share({
      title,
      message,
      url
    });
    return;
  }
  var text = [
    message,
    url
  ].filter(Boolean).join(" ");
  if (!text) throw new Error("openShare: pass a message or a url");
  await import_react_native.Share.share({
    title,
    message: text
  });
}
async function openSettings() {
  await import_react_native.Linking.openSettings();
}
var Open = Object.freeze({
  openURL,
  openShare,
  openSettings
});
//# sourceMappingURL=index.native.js.map
